export default __webpack_public_path__ + "static/media/bs1.6de65476.jpeg";